import { render } from "./close-arrow-icon.vue?vue&type=template&id=7f2d9809"
import script from "./close-arrow-icon.vue?vue&type=script&lang=js"
export * from "./close-arrow-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__